import { usePublicBasket } from "@app-contexts/public/features/basket/services/usePublicBasket";
import CartSummaryContainer from "@app-contexts/public/features/basket/components/CartSummaryContainer/CartSummaryContainer.web";
import Icon from "@ui-kit/icons/Icon.web";
import Box from "@ui-kit/layout/Box/Box.web";
import Button from "@ui-kit/form/Button/Button.web";
import { Timer } from "@ui-kit/feedback/timer/Timer";
import useRedirect from "@shared/hooks/useRedirect.web";
import { useRouter } from "next/router";
import { useEffect, useState } from "react";
import { useTranslation } from "@shared/utils/internationalization";
import { PUBLIC_ROUTES } from "@app-contexts/public/constants/public-routes";
import { NavBarCartDisplayProps } from "./NavBarCartDisplay.props";

const NavBarCartDisplay = ({
  isDetailPage: _isDetailPage,
}: NavBarCartDisplayProps) => {
  const { t } = useTranslation("common");
  const { redirect } = useRedirect();
  const router = useRouter();
  const [mounted, setMounted] = useState(false);
  const {
    hasItems,
    expiryDate,
    isBasketUpdating,
    totalItemQuantity,
    paymentVenue,
  } = usePublicBasket();
  const navigateToCheckout = () => redirect(PUBLIC_ROUTES.CHECKOUT.ROOT);

  const holdLink = router.query.link as string;

  useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted || !hasItems || !expiryDate) return null;

  return (
    <CartSummaryContainer
      displayMode="drawer"
      onCheckout={navigateToCheckout}
      venueId={paymentVenue}
      holdLink={holdLink}
      renderButton={({ onOpen, isOpen }) => (
        <Button.Nav
          data-testid="navbar-cart-display-button"
          aria-label={t(
            "Cart button with {{count}} items, Action: {{action}}",
            {
              count: totalItemQuantity,
              action: t("Open Cart Summary Modal"),
            }
          )}
          isLoading={isBasketUpdating}
          onClick={onOpen}
          leftIcon={<Icon.Cart.Outline boxSize="element.lg" color="fg" />}
        >
          <span>({totalItemQuantity})</span>
          <Box w="element.2xs" />
          <Timer
            targetDate={expiryDate}
            disableLiveAnnouncements={isOpen}
            announcementSuffix={t("left to complete transaction!")}
          />
        </Button.Nav>
      )}
    />
  );
};

export default NavBarCartDisplay;
